import { get } from '../../http';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  async getList (context, { platform, params }) {
    return await get(`/${platform}/analysis/list`, params)
  },
  async getOptions (context, { platform, field } = {}) {
    return await get(`/${platform}/analysis/option`, { field })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};
